var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Megaphone = function Megaphone(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.348 2.512A2 2 0 0 1 22 4.402v12.285a2 2 0 0 1-2.532 1.928l-10.12-2.792.447 2.458a2 2 0 0 1-1.72 2.342l-1.998.25a2 2 0 0 1-2.221-1.656L3.153 15H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h3.467a2 2 0 0 1 .381-.178l12.5-4.31ZM5.18 15l.649 3.889 1.998-.25-.62-3.406-.239-.067A2.003 2.003 0 0 1 6.552 15H5.18Zm.32-2H3V9h2.5v4ZM20 4.403 7.5 8.713v4.526L20 16.686V4.403Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Megaphone;